<div class="info-card" [ngClass]="[type(), addClass()]">
  <p class="m-0 text-sm"><fa-icon [icon]="icon()" size="sm" /><ng-content></ng-content></p>
</div>
